export default "__VITE_ASSET__BszvtffT__"